import { render, staticRenderFns } from "./content_btn.vue?vue&type=template&id=054503a9&scoped=true&"
import script from "./content_btn.vue?vue&type=script&lang=js&"
export * from "./content_btn.vue?vue&type=script&lang=js&"
import style0 from "./content_btn.vue?vue&type=style&index=0&id=054503a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054503a9",
  null
  
)

export default component.exports